<template>
  <div class="container">
    <div class="row how-we-calculate">
      <p>Wycena na podstawie</p>
      <ul class="disable-flex-shrink">
        <li>pracochłonności napraw wg. norm producentów</li>
        <li>
          aktualnych stawek roboczogodzin wybranych warsztatów z obszaru Polski
        </li>
        <li>kosztów części - uśrednionych cen rynkowych</li>
        <li>wycen warsztatów referencyjnych</li>
      </ul>
    </div>

    <img
      src="/static/images/TecRMIInsideBadgeBlack.svg"
      class="signet"
      alt="TecRMI Signet"
    />

    <div class="row source">
      <p>
        Źródło: Dane z okresu {{ dateFromPeriod }}.<br />Stawki roboczogodzin na
        podstawie ankiet własnych prowadzonych wśród warsztatów mechanicznych na
        terenie Polski, koszty części na podstawie uśrednionych cen rynkowych -
        opracowanie własne.
      </p>
      <p>
        Uwaga: Wszelkie informacje, dane i kwoty zamieszczone w serwisie są
        udostępniane jedynie w celach informacyjnych bez jakichkolwiek
        gwarancji. Mimo dołożenia wszelkich możliwych starań Spółka nie
        gwarantuje, że informacje i dane zawarte w Serwisie Internetowym są
        wolne od uchybień i błędów. Jakakolwiek informacja czy porada uzyskana
        poprzez niniejszy Serwis Internetowy nie może być podstawą do żądania
        odszkodowania od jakiejkolwiek strony ani być podstawą roszczeń.
        Usługodawca nie gwarantuje ani kwoty ani możliwości wykonania naprawy w
        warsztacie własnym ani jakimkolwiek innym.
      </p>
    </div>
  </div>
</template>
<script setup>
import { onMounted, ref } from "vue";

const dateFromPeriod = ref("");

onMounted(() => {
  function dateFormat(date) {
    const monthFormat = (date.getMonth() + 1).toString().padStart(2, "0");
    const yearFormat = date.getFullYear();
    return `${monthFormat}.${yearFormat}`;
  }

  const currentDate = new Date();
  const sixMonthAgo = new Date();
  sixMonthAgo.setMonth(sixMonthAgo.getMonth() - 6);
  dateFromPeriod.value = `${dateFormat(sixMonthAgo)} - ${dateFormat(
    currentDate
  )}`;
});
</script>
<style scoped>
.signet {
  width: 150px;
  display: block;
  margin-left: auto;
  margin-top: 30px;
  margin-bottom: 30px;
}

.how-we-calculate {
  margin-top: 35px;
  font-size: 18px;
  color: rgba(121, 121, 121, 1);
  font-weight: 400;
}
.source {
  font-size: 13px;
  font-weight: 400;
  color: rgba(121, 121, 121, 1);
  margin-top: 35px;
  margin-left: 12px;
}

.disable-flex-shrink {
  flex-shrink: initial;
}

.how-we-calculate ul {
  margin-left: 40px;
}
</style>
